export interface FinancialAccount {
  type: string
  id: string
  attributes: {
    key: string
    label: string
    account_type: string
    created_at: number
    updated_at: number
  }
  relationships: {
    parent: {
      type: string
      id: string
    }
  }
}

export const financialAccountAttributes = [
  "key",
  "label",
  "account_type",
  "created_at",
  "updated_at"
]
